/* Previous theme settings for .lp-legacy landing pages */
(function () {
  let root = '/';
    if (root[root.length - 1] !== '/') {
      root = `${root}/`;
    }
  var lp = {
      routes: {
        root_url: root,
        cart: '/cart',
        cart_add_url: '/cart/add',
        product_recommendations_url: '/recommendations/products',
        account_addresses_url: '/account/addresses',
        predictive_search_url: '/search/suggest'
      },
      state: {
        cartOpen: null,
      },
      sizes: {
        small: 480,
        medium: 768,
        large: 1100,
        widescreen: 1400
      },
      assets: {
        photoswipe: '//saunabox.com/cdn/shop/t/226/assets/lp-photoswipe.js?v=162613001030112971491792112321',
        smoothscroll: '//saunabox.com/cdn/shop/t/226/assets/smoothscroll.js?v=37906625415260927261792112322',
        swatches: '//saunabox.com/cdn/shop/t/226/assets/swatches.json?v=158395026418322710421792112321',
        noImage: '//saunabox.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12.gif',
        base: '//saunabox.com/cdn/shop/t/226/assets/'
      },
      strings: {
        swatchesKey: "Color, Colour",
        addToCart: "Add to Cart",
        estimateShipping: "Estimate shipping",
        noShippingAvailable: "We do not ship to this destination.",
        free: "Free",
        from: "From",
        preOrder: "Pre-order",
        soldOut: "Sold Out",
        sale: "Sale",
        subscription: "Subscription",
        unavailable: "Unavailable",
        unitPrice: "Unit price",
        unitPriceSeparator: "per",
        stockout: "All available stock is in cart",
        products: "Products",
        pages: "Pages",
        collections: "Collections",
        resultsFor: "Results for",
        noResultsFor: "No results for",
        articles: "Articles",
        successMessage: "Link copied to clipboard",
      },
      settings: {
        badge_sale_type: "dollar",
        animate_hover: false,
        animate_scroll: false,
        show_locale_desktop: null,
        show_locale_mobile: null,
        show_currency_desktop: null,
        show_currency_mobile: null,
        currency_select_type: "country",
        currency_code_enable: false,
        cycle_images_hover_delay: 1.5,
        cart_style: "page"
      },
      info: {
        name: 'pipeline'
      },
      version: '7.0.2',
      moneyFormat: "${{amount}}",
      shopCurrency: "USD",
      currencyCode: "USD"
    };
  var t = window.theme = window.theme || {};
  Object.keys(lp).forEach(function (k) {
    if (!(k in t)) { t[k] = lp[k]; return; }
    if (t[k] && typeof t[k] === 'object' && lp[k] && typeof lp[k] === 'object')
      Object.keys(lp[k]).forEach(function (s) { if (!(s in t[k])) t[k][s] = lp[k][s]; });
  });
})();
function lpDefine(name, ctor, opts) { if (!customElements.get(name)) customElements.define(name, ctor, opts); }
